import { createBaseStore } from "@shared/store/createBaseStore";
import config from "../config";

export default createBaseStore(config);
